import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { ContentfulService } from '../contentful.service';
import { Entry } from 'contentful';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import { BLOCKS, MARKS } from '@contentful/rich-text-types';

import { from } from 'rxjs/observable/from';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-individual-faq',
  templateUrl: './individual-faq.component.html',
  styleUrls: ['./individual-faq.component.css']
})
export class IndividualFaqComponent implements OnInit {

  courses: Entry<any>[] = [];
  faqs: Entry<any>[] = [];
  categories: Entry<any>[] = [];
  menuOpen: boolean = false;
  accItemShow: boolean = false;
  accItem: any;
  individualFaq: Entry<any>;
  faqArr:any = [];
  faqCategories:any =[];

  mydata: any;
  document1: any;
  faqId:any;
  siteUrl: any = environment.siteUrl;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private contentfulService: ContentfulService
  ) { }

  ngOnInit() {
      
      this.contentfulService.getFaqs()
      //.then(faqs => this.faqs = faqs);
      .then((faqs) => {
        this.faqs = faqs;
        let faqsData = this.faqs;
        
        for (var i = 0; i < faqsData.length; i++) {
          var category = faqsData[i].fields.category;
          this.faqCategories.push(faqsData[i].fields.category)
          if (!this.faqArr[category]) {
            this.faqArr[category] = [];
          }
          this.faqArr[category].push({'id':faqsData[i].sys.id, 'title':faqsData[i].fields.title, 'answer':faqsData[i].fields.answer, 'iframe_field': faqsData[i].fields.iframe_field});
        }
          this.faqCategories = this.faqCategories.filter((value, index) => this.faqCategories.indexOf(value) === index); 
          this.faqCategories = this.faqCategories.reverse();
      }); 


      this.faqId = this.route.snapshot.paramMap.get('id');
    this.contentfulService.getFaq(this.faqId)
      .then((faq) => {
        this.individualFaq = faq;
        //console.log(this.individualFaq);
        this.showPopularQuestion(this.individualFaq.sys.id, this.individualFaq.fields.category, true);
      });
      
  }

  goToCourseDetailsPage(courseId) {
    this.router.navigate(['/news', courseId]);
  }

  toggleMenu(){
    this.menuOpen = !this.menuOpen;
  }

  accordion(index){    
    this.accItem = index;
    this.accItemShow = !this.accItemShow;

    let accBodyShow = document.getElementById('accBody_'+index).classList.contains('show');

    if(accBodyShow){
      document.getElementById('accBody_'+index).classList.remove('show');
      document.getElementById('accHeading_'+index).classList.remove('fa-angle-up');
      document.getElementById('accHeading_'+index).classList.add('fa-angle-right');
    }else{
      document.getElementById('accBody_'+index).classList.add('show');
      document.getElementById('accHeading_'+index).classList.add('fa-angle-up');
      document.getElementById('accHeading_'+index).classList.remove('fa-angle-right');
    }
  }

  searchFaqs() {
    var input, filter, ele, i, txtValue, x;
    input = document.getElementById("myInput");
    filter = input.value.toUpperCase();
    ele = document.getElementsByTagName("h5");
     x = document.getElementsByClassName('card');
    if( filter.length >= 3){
      
      for (i = 0; i < ele.length; i++) { 
          txtValue = ele[i].textContent || ele[i].innerText;
          if (txtValue.toUpperCase().indexOf(filter) > -1) {
              x[i].classList.remove('hide');
              let catId = x[i].getAttribute("lang");
              let faqId = x[i].getAttribute("title");
              document.getElementById(catId).classList.add('open');
              document.getElementById("accBody_"+faqId).classList.add('show');
              document.getElementById("accHeading_"+faqId).classList.add('fa-angle-up');
              document.getElementById("accHeading_"+faqId).classList.remove('fa-angle-right');
          } else {
            x[i].classList.add('hide');
          }
      }
    }else{
      for (i = 0; i < ele.length; i++) { 
        x[i].classList.remove('hide');
      }
    }
}

toggleCategory(category){

  var accCatHead, accCatBody, accBody, accHead, catHeadClass, i, j, k, l, m, accCard, input;

  accCatHead = document.getElementsByClassName('acc-cat-head-icon');
  accCatBody = document.getElementsByClassName('faq-categories');
  accBody = document.getElementsByClassName('collapse');
  accHead = document.getElementsByClassName('acc-head-icon');
  accCard = document.getElementsByClassName('card');
  catHeadClass= document.getElementById(category+'_icon').classList.contains('fa-angle-up');

  input = document.getElementById("myInput");
  input.value = "";
  
  for (j = 0; j < accCatBody.length; j++) { 
    accCatBody[j].classList.remove('open');
  }

  for (k = 0; k < accBody.length; k++) { 
    accBody[k].classList.remove('show');
  }

  for (l = 0; l < accHead.length; l++) { 
    accHead[l].classList.remove('fa-angle-right');
    accHead[l].classList.add('fa-angle-up');
  }

  if(!catHeadClass){
    
    for (i = 0; i < accCatHead.length; i++) { 
      accCatHead[i].classList.remove('fa-angle-up');
      accCatHead[i].classList.add('fa-angle-right');
    }

    for (k = 0; k < accBody.length; k++) { 
      accBody[k].classList.add('show');
    }

    for (m = 0; m < accCard.length; m++) { 
      accCard[m].classList.remove('hide');
    }

    document.getElementById(category+'_icon').classList.remove('fa-angle-right');
    document.getElementById(category+'_icon').classList.add('fa-angle-up');
    document.getElementById(category).classList.add('open');
  }else{
    document.getElementById(category+'_icon').classList.remove('fa-angle-up');
    document.getElementById(category+'_icon').classList.add('fa-angle-right');
    //document.getElementById(category).classList.remove('open');
  }

}

showPopularQuestion(index, category, selectedQuestion?){

  var ele, i, x, input, cat, j, catHead, k, accBody, l, accCatHead, m;
  x = document.getElementsByClassName('card');
  ele = document.getElementsByTagName("h5");
  accCatHead = document.getElementsByClassName('acc-cat-head-icon');
  for (i = 0; i < ele.length; i++) { 
    x[i].classList.remove('hide');
    x[i].classList.remove('popularQ');
  }
  input = document.getElementById("myInput");
  input.value = "";
  this.accItem = index;
  this.accItemShow = true;

  cat = document.getElementsByClassName('faq-categories');
  for (j = 0; j < cat.length; j++) { 
    cat[j].classList.remove('open');
  }
  catHead = document.getElementsByClassName('acc-head-icon');
  accBody = document.getElementsByClassName('collapse');
  for (k = 0; k < catHead.length; k++) { 
    catHead[k].classList.remove('fa-angle-up');
    catHead[k].classList.add('fa-angle-right');
  }

  for (l = 0; l < accBody.length; l++) { 
    accBody[l].classList.remove('show');
  }

  for (m = 0; m < accCatHead.length; m++) { 
    accCatHead[m].classList.remove('fa-angle-up');
    accCatHead[m].classList.add('fa-angle-right');
  }
  
    document.getElementById(category).classList.add('open');
    document.getElementById(category+'_icon').classList.add('fa-angle-up');
    document.getElementById(category+'_icon').classList.remove('fa-angle-right');
    document.getElementById('accBody_'+index).classList.add('show');
    document.getElementById('accHeading_'+index).classList.add('fa-angle-up');
    document.getElementById('accHeading_'+index).classList.remove('fa-angle-right');
    if(!selectedQuestion){
      document.getElementById('card_'+index).classList.add('popularQ');
    }
    
  
}

_returnHtmlFromRichText(richText) {
  if (richText === undefined || richText === null || richText.nodeType !== 'document') {
    return '<p>Error</p>';
  }
  /*
  const options = {
    renderMark: {
      [MARKS.BOLD]: text => `<custom-bold>${text}<custom-bold>`
    },
    renderNode: {
      [BLOCKS.PARAGRAPH]: (node, next) =>
        `<custom-paragraph>${next(node.content)}</custom-paragraph>`
    }
  };

  const options = {
    renderNode: {
        [BLOCKS.EMBEDDED_ASSET]: ({ data: { target: { fields }}}) =>
            `<img src="${fields.file.url}" height="${fields.file.details.image.height}" width="${fields.file.details.image.width}" alt="${fields.description}"/>`,
    },
};
*/
  return documentToHtmlString(richText);
}

goToFaqPage(faqId) {
  this.router.navigate(['/faq', faqId]);
}

createElementFromHTML(htmlString) {
  document.getElementById('iframeElement').innerHTML="";
  var div = document.createElement('div');
  div.innerHTML = htmlString.trim();
  div.setAttribute('id', 'elementId');
  //return div.firstChild; 
  document.getElementById('iframeElement').appendChild(div.firstChild); 
}

}





// WEBPACK FOOTER //
// /Users/ranjith/eclipse-workspace/monarch-web-contentful/src/app/individual-faq/individual-faq.component.ts